import { showErrorNotification } from 'src/components/common/Notifications';

export const handleRequestError = error => {
  if (error.response?.data) {
    // Axios error
    const serverErrorMessage = error.response?.data?.message || 'Something went wrong';
    showErrorNotification(serverErrorMessage, 4500);
  } else if (error instanceof Error) {
    // General error
    showErrorNotification(error.message, 4500);
  } else {
    showErrorNotification('An unexpected error occurred', 4500);
  }
};
